export default __webpack_public_path__ + "static/media/281.717f0eba.jpg";